export default __webpack_public_path__ + "static/media/CheckCircle.a2170396.svg";